import { FormControl } from '@angular/forms';
import { TipoOperacaoEnum } from '../enums/motor-fiscal/tipo-operacao.enum';

const DIGITOS_ENTRADA = ['1', '2', '3'];
const DIGITOS_SAIDA   = ['5', '6', '7'];

/**
 * Aplica/remove o erro `cfopTipoInvalido` no controle conforme o tipo de operação.
 * Preserva quaisquer outros erros já presentes no controle.
 *
 * Regra: se o 1º caractere do valor for um dígito numérico que não pertence ao
 * conjunto válido para o tipoOperacao informado, o campo fica inválido.
 * O caractere '?' é sempre aceito (substituição automática por 1/2/3 ou 5/6/7).
 */
export function validarCfopPorTipo(control: FormControl, tipoOperacao: TipoOperacaoEnum | null): void {
    const valor = control.value as string | null | undefined;
    if (!valor) {
        removerErro(control);
        return;
    }

    const primeiro = valor.charAt(0);
    if (primeiro === '?' || !/^\d$/.test(primeiro)) {
        removerErro(control);
        return;
    }

    const digitosValidos = tipoOperacao === TipoOperacaoEnum.Entrada ? DIGITOS_ENTRADA : DIGITOS_SAIDA;

    if (!digitosValidos.includes(primeiro)) {
        control.setErrors({ ...(control.errors ?? {}), cfopTipoInvalido: { tipoOperacao } });
    } else {
        removerErro(control);
    }
}

function removerErro(control: FormControl): void {
    const erros = control.errors;
    if (!erros || !('cfopTipoInvalido' in erros)) return;
    const { cfopTipoInvalido, ...restErrors } = erros;
    control.setErrors(Object.keys(restErrors).length ? restErrors : null);
}
